import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelect } from 'primeng/multiselect';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../../shared/alpha-shared.module';
import { JoinPipe } from '../../../users/joinpipe/join.pipe';

@Component({
    selector: 'app-filter-enum',
    standalone: true,
    imports: [...PrimeNGModules, ReactiveFormsModule, AutoCompleteModule, TranslatePipe, JoinPipe],
    templateUrl: './filter-enum.component.html',
    styleUrl: './filter-enum.component.scss',
})
export class FilterEnumComponent implements OnChanges {
    @Input() enumInput: any;
    @Input() formGroup!: FormGroup;
    @Input() controlName: string = '';
    @Input() autocomplete: boolean = false;

    filteredEnumInput: string[] = [];
    selectedOptions: string[] = [];
    filterSearch: string = '';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['formGroup'] || changes['controlName']) {
            if (this.enumInput?.length) {
                this.restoreSelections();
                this.search('');
            }
        }
    }

    private restoreSelections() {
        if (!this.formGroup || !this.controlName || !this.enumInput?.length) return;

        const group = this.formGroup.get([this.controlName]);
        if (!(group && group.value)) return;

        const groupValue = group.value;

        this.selectedOptions = this.enumInput.filter((key: string) => groupValue[key]);
    }

    search(value: string) {
        const query = (value || '').toLowerCase().trim();
        if (!query) {
            this.filteredEnumInput = this.enumInput;
            return;
        }
        this.filteredEnumInput = this.enumInput.filter((opt: string) => opt.toLowerCase().includes(query));
    }

    onRemove(label: string, index: number) {
        const group = this.formGroup.get([this.controlName, label]);
        group?.setValue(false);
        this.selectedOptions.splice(index, 1);
    }

    onMultiSelectChange() {
        const group = this.formGroup.get([this.controlName]);
        this.enumInput.forEach((key: string) => {
            const isSelected = this.selectedOptions.includes(key);
            group?.get(key)?.setValue(isSelected);
        });
    }

    onDropdownOpen(event: MultiSelect) {
        event.dropdownIcon = 'pi pi-chevron-up';
    }

    onDropdownClose(event: MultiSelect) {
        event.dropdownIcon = 'pi pi-chevron-down';
    }
}
